interface ColumnPref {
  columnId: string
  visible: boolean
}

type AlertsFilters = Record<string, string[]>

// A filter on a hidden column has no header to clear it from, so it must not keep applying.
export const omitHiddenColumnFilters = (filters: AlertsFilters, columnPrefs?: ColumnPref[]): AlertsFilters => {
  if (!columnPrefs?.length) {
    return filters
  }

  const hiddenIds = columnPrefs.filter(({ visible }) => !visible).map(({ columnId }) => columnId)
  const hiddenFilterKeys = Object.keys(filters).filter((key) => hiddenIds.includes(key) && filters[key]?.length)

  if (!hiddenFilterKeys.length) {
    return filters
  }

  const cleaned = { ...filters }
  hiddenFilterKeys.forEach((key) => {
    cleaned[key] = []
  })
  return cleaned
}
